import { useState } from "react";
import "./AdminBannerEditar.css";

function AdminBannerEditar({
    banner,
    onClose,
    onSalvar,
}) {
    const [arquivo, setArquivo] = useState(null);
    const [preview, setPreview] = useState(null);

    const isBannerMobile =
        banner.localizacao?.includes("mobile");

    const handleSelecionarImagem = (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        setArquivo(file);

        const reader = new FileReader();

        reader.onload = (event) => {
            setPreview(event.target.result);
        };

        reader.readAsDataURL(file);
    };

    const [salvando, setSalvando] = useState(false);

    const handleSalvar = async () => {
        if (!arquivo) {
            alert("Selecione uma imagem.");
            return;
        }

        try {
            setSalvando(true);

            // 1 - Upload da imagem
            const formData = new FormData();
            formData.append("imagem", arquivo);

            const uploadResponse = await fetch(
                "https://app.eliandroalimentos.com.br/api/imagem/upload",
                {
                    method: "POST",
                    body: formData,
                }
            );

            const uploadData = await uploadResponse.json();

            if (!uploadResponse.ok) {
                throw new Error(
                    uploadData.message || "Erro ao fazer upload"
                );
            }

            console.log("Upload realizado:", uploadData);

            // caminho retornado pela API
            const novaImagem = uploadData.caminho;

            // 2 - Atualizar banner
            const editarResponse = await fetch(
                "https://app.eliandroalimentos.com.br/api/home_media/editarimagembanner",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: banner.id,
                        imagem: novaImagem,
                    }),
                }
            );

            const editarData = await editarResponse.json();

            if (!editarResponse.ok || !editarData.success) {
                throw new Error(
                    editarData.message ||
                    "Erro ao atualizar banner"
                );
            }

            console.log("Banner atualizado:", editarData);

            alert("Banner atualizado com sucesso!");

            if (onSalvar) {
                onSalvar({
                    ...banner,
                    imagem: novaImagem,
                });
            }

            onClose();
        } catch (error) {
            console.error(error);

            alert(
                error.message ||
                "Erro ao atualizar banner"
            );
        } finally {
            setSalvando(false);
        }
    };

    return (
        <div
            className="admin-banner-editar-overlay"
            onClick={onClose}
        >
            <div
                className="admin-banner-editar"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="admin-banner-editar-header">
                    <h2>
                        Editar Banner {banner.ordem}
                    </h2>

                    <button
                        className="fechar"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>

                <div className="admin-banner-conteudo">

                    {/* IMAGEM ATUAL */}
                    <div className="bloco-preview">
                        <h3>Imagem Atual</h3>

                        <div
                            className={
                                isBannerMobile
                                    ? "preview-banner preview-banner-mobile"
                                    : "preview-banner"
                            }>
                            <img
                                src={banner.imagem}
                                alt=""
                            />
                        </div>
                    </div>

                    {/* NOVA IMAGEM */}
                    <div className="bloco-preview">
                        <h3>Nova Imagem (Desktop - 7090 × 2000 px / Mobile - 1535 × 9331 px) .jpg</h3>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleSelecionarImagem}
                        />

                        {preview && (
                            <div className="preview-original">
                                <img
                                    src={preview}
                                    alt=""
                                />
                            </div>
                        )}
                    </div>

                    {/* SIMULAÇÃO */}
                    {preview && (
                        <div className="bloco-preview">
                            <h3>Como ficará no site</h3>

                            <div className={
                                isBannerMobile
                                    ? "preview-banner preview-banner-mobile"
                                    : "preview-banner"
                            }>
                                <img
                                    src={preview}
                                    alt=""
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="admin-banner-footer">
                    <button
                        className="btn-cancelar"
                        onClick={onClose}
                    >
                        Cancelar
                    </button>

                    <button
                        className="btn-salvar"
                        onClick={handleSalvar}
                        disabled={salvando}
                    >
                        {salvando ? "Salvando..." : "Salvar"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AdminBannerEditar;